import { SAFE_DISPLAY_ALLOWED_SPECIAL_CHARACTERS } from '@/utils/constants';
import { getIntl } from 'umi';

const escapedAllowedSpecialCharacters = SAFE_DISPLAY_ALLOWED_SPECIAL_CHARACTERS.split(' ')
  .filter(Boolean)
  .map((char) => char.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'))
  .join('');

// Do not Object.freeze this RegExp: async-validator sets lastIndex before .test().
export const SAFE_DISPLAY_TEXT_CHAR_PATTERN = new RegExp(
  `^[0-9A-Za-z\\u00C0-\\u024F\\u0400-\\u04FF\\u1E00-\\u1EFF\\s${escapedAllowedSpecialCharacters}]*$`,
);

export const SAFE_DISPLAY_TEXT_CHAR_RULE_MESSAGE_ID = 'form.error.safeDisplayText';

export function safeDisplayTextCharRule(messageId = SAFE_DISPLAY_TEXT_CHAR_RULE_MESSAGE_ID) {
  return {
    pattern: SAFE_DISPLAY_TEXT_CHAR_PATTERN,
    message: getIntl().formatMessage(
      { id: messageId },
      { allowedChars: SAFE_DISPLAY_ALLOWED_SPECIAL_CHARACTERS },
    ),
  };
}
